import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { WarningAmber } from "@mui/icons-material";
import { useGetEingangsrechnung } from "../../client/hooks";
import { EingangsrechnungInfo } from "../../api";

export default function StorniertWarnung({
  storniertAm,
  stornoRechnungId,
}: {
  storniertAm: string | null;
  stornoRechnungId: string;
}) {
  const getRechnung = useGetEingangsrechnung();
  const [stornoRechnung, setStornoRechnung] = useState<
    EingangsrechnungInfo | undefined
  >(undefined);

  const [isStorniert, setIsStorniert] = useState<boolean>(false);

  useEffect(() => {
    const fetchRechnung = async () => {
      if (stornoRechnungId) {
        let rechnung = await getRechnung(stornoRechnungId);
        setStornoRechnung(rechnung);
      }
    };
    fetchRechnung();
  }, [stornoRechnungId]);

  useEffect(() => {
    setIsStorniert(
      storniertAm !== null && storniertAm !== "" && storniertAm !== undefined
    );
  }, [storniertAm]);

  return (
    <>
      {isStorniert ? (
        <Typography variant="h5" color={"error"}>
          <WarningAmber />
          Rechnung wurde am{" "}
          {storniertAm &&
            new Date(storniertAm).toLocaleDateString("de-DE")}{" "}
          {stornoRechnung?.rechnungsNummer
            ? `durch den Stornobeleg ${stornoRechnung.rechnungsNummer}`
            : null}{" "}
          storniert.
        </Typography>
      ) : (
        <></>
      )}
    </>
  );
}
